import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

export const inova: GetCustomerCopyFunc = () => {
  return {
    workLifeServicesCustomDescription: 'Financial advice, legal services, family support, and more.',
  }
}
